import { $api } from "services";
import { TSuggestionsResponse } from "types/suggestions";
import { suggestionsStore } from "./store";

class SuggestionsApi {
  private handleError(error: any) {}

  async getSuggestions(
    page: number = 0,
    take: number = 10,
    searchQuery?: string
  ): Promise<TSuggestionsResponse> {
    const { setIsLoading } = suggestionsStore.getState();

    const url = `/api/extension/crypto-projects`;
    try {
      setIsLoading(true);
      const { data } = await $api.get<TSuggestionsResponse>(url, {
        params: {
          page,
          limit: take,
          searchQuery: searchQuery ? searchQuery : null
        }
      });

      return data;
    } catch (error) {
      this.handleError(error);

      return {
        data: [],
        total: 0,
        pages: 0,
        page: 0,
        limit: 0
      };
    } finally {
      setIsLoading(false);
    }
  }

  async approveList(list: string[]) {
    const url = `/api/extension/crypto-projects/approve`;
    const { setApproveProcessings, setSelectedSuggestions } =
      suggestionsStore.getState();

    try {
      setApproveProcessings(list);
      await $api.post(url, { twittersList: list });
      setSelectedSuggestions([]);
    } catch (error) {
      this.handleError(error);
    } finally {
      setApproveProcessings([]);
    }
  }

  async approve(list: string[]) {
    const isConfirmed = window.confirm(
      `Are you sure you want to approve these suggestion${
        list.length > 1 ? "s" : ""
      }?`
    );

    if (isConfirmed) {
      await this.approveList(list);
    }
  }

  toggleSuggestion(twitter: string) {
    const { selectedSuggestions, setSelectedSuggestions } =
      suggestionsStore.getState();
    const newSelectedSuggestions = selectedSuggestions.includes(twitter)
      ? selectedSuggestions.filter((s) => s !== twitter)
      : [...selectedSuggestions, twitter];

    setSelectedSuggestions(newSelectedSuggestions);
  }

  toggleAll(list: string[]) {
    const { selectedSuggestions, setSelectedSuggestions } =
      suggestionsStore.getState();
    const isSomeSelected = selectedSuggestions.length > 0;
    const newSelectedSuggestions = isSomeSelected ? [] : list;

    setSelectedSuggestions(newSelectedSuggestions);
  }
}

export const suggestionService = new SuggestionsApi();
